import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@mui/material';
import { animated, useTransition } from '@react-spring/web';
import clsx from 'clsx';
import i18n from 'i18n-react';

import { useCookieConsent } from 'hooks/useCookieConsent';

import c from './_cookieConsent.module.scss';

const AnimatedBox = animated(Box);

export interface CookieConsentProps {
  disabled?: boolean;
}

export function CookieConsent({ disabled = false }: CookieConsentProps) {
  const [cookieConsent, setCookieConsent] = useCookieConsent();

  const style = useTransition(cookieConsent === undefined, {
    from: { opacity: 0, transform: 'translateY(-100%)' },
    enter: { opacity: 1, transform: 'translateY(0%)' },
    leave: { opacity: 0, transform: 'translateY(-100%)' },
  });

  if (disabled) {
    return null;
  }

  return style((style, item) => {
    if (item === false) {
      return null;
    }

    return (
      <AnimatedBox className={clsx('cookieConsent', c.wrapper)} style={style}>
        <Typography className="cookieText">
          <FontAwesomeIcon className={c.icon} icon={['fas', 'shield-alt']} />
          {i18n.translate('cookies.message')}
        </Typography>

        <Button
          className={c.button}
          variant="text"
          onClick={() => {
            setCookieConsent(false);
          }}
        >
          {i18n.translate('cookies.optout')}
        </Button>

        <Button
          className={c.button}
          variant="contained"
          onClick={() => {
            setCookieConsent(true);
          }}
        >
          {i18n.translate('cookies.consent')}
        </Button>
      </AnimatedBox>
    );
  });
}
